/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GolabAppDescription } from '../../models/golab-app-description';

export interface GolabAppControllerGetGraaspAppList$Params {
}

export function golabAppControllerGetGraaspAppList(http: HttpClient, rootUrl: string, params?: GolabAppControllerGetGraaspAppList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GolabAppDescription>>> {
  const rb = new RequestBuilder(rootUrl, golabAppControllerGetGraaspAppList.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<GolabAppDescription>>;
    })
  );
}

golabAppControllerGetGraaspAppList.PATH = '/golab-app/graasp-app-list';
